import { useState } from "react";

import { Button } from "@sirdab/ui";

import { useMessages } from "../i18n";
import { useTheme } from "../theme";

/**
 * The merchant's logo and name, and nothing else. docs/08: "Never block on an image
 * loading" — the logo is lazily decoded and simply disappears on error; the name, when the
 * policy supplies one, always renders.
 */
export function MerchantHeader(): React.JSX.Element {
  const { logoUrl, displayName } = useTheme();
  const { text, locale, toggleLocale, t } = useMessages();
  const [logoFailed, setLogoFailed] = useState(false);

  return (
    <div className="flex items-center justify-between gap-3 py-4">
      <div className="flex min-w-0 items-center gap-2.5">
        {logoUrl !== null && !logoFailed ? (
          <img
            src={logoUrl}
            alt=""
            loading="lazy"
            decoding="async"
            onError={() => setLogoFailed(true)}
            className="h-8 w-auto max-w-28 object-contain"
          />
        ) : null}
        {displayName != null ? (
          <span className="text-label truncate text-foreground">
            {text(displayName)}
          </span>
        ) : null}
      </div>

      <Button
        type="button"
        variant="chip"
        size="sm"
        onClick={toggleLocale}
        aria-label={t("ui.language_switch")}
        className="shrink-0"
      >
        {/* The name of a language is written in that language — not catalogue copy. */}
        <span lang={locale === "ar" ? "en" : "ar"}>
          {locale === "ar" ? "English" : "العربية"}
        </span>
      </Button>
    </div>
  );
}
